import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {NgxNavbarModule} from 'ngx-bootstrap-navbar';
import {RouterLink} from '@angular/router';
import {ContentHeaderComponent} from '../content-header/content-header.component';
import {Breadcrumb} from '../../entities/breadcrumb.entity';
import {BreadcrumbService} from '../../services/breadcrumb.service';
import {Location, NgTemplateOutlet} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  imports: [
    RouterLink,
    ContentHeaderComponent,
    NgxNavbarModule,
    NgTemplateOutlet,
    TranslatePipe,
  ],
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit {
  public breadcrumbs: Breadcrumb[] = [];

  public constructor(
    private cdr: ChangeDetectorRef,
    private breadcrumbService: BreadcrumbService,
    public readonly location: Location,
  ) {
  }

  public ngOnInit() {
    this.breadcrumbService.breadcrumbs$.subscribe(value => {
      this.breadcrumbs = value;
      this.cdr.markForCheck();
    });
  }
}
